export const docs_catalog_1 = [
    {
        "n": 'cat1-1',
        "pregunta": "1. Aproximadamente, ¿cuánto tiempo le han ocupado al día los pensamientos de contaminación y las conductas de limpieza debidas a la contaminación?",
        "respuestas": [
            "0.- Ninguno",
            "1.- Menos de una hora al día",
            "2.- Entre 1 y 3 horas al día",
            "3.- Entre 3 y 8 horas al día",
            "4.- Ocho horas o más al día   ",
        ]
    },
    {
        "n": 'cat1-2',
        "pregunta": "2. ¿Ha evitado situaciones para no tener pensamientos de contaminación o para no tener que pasar tiempo lavándose, limpiando o duchándose?",
        "respuestas": [
            "0.- En absoluto",
            "1.- Evitación leve",
            "2.- Evitación moderada",
            "3.- Evitación grave",
            "4.- Evitación extrema de casi todas las cosas",
        ]
    },
    {
        "n": 'cat1-3',
        "pregunta": "3. Si ha tenido pensamientos de contaminación pero no ha podido limpiar, lavarse o ducharse (ni eliminar la contaminación de otra forma), ¿cuánto malestar o ansiedad ha tenido?",
        "respuestas": [
            "0.- Ningún malestar/ansiedad",
            "1.- Ansiedad/malestar leve",
            "2.- Ansiedad/malestar moderado",
            "3.- Ansiedad/malestar grave",
            "4.- Ansiedad/malestar extremo",
        ]
    },
    {
        "n": 'cat1-4',
        "pregunta": "4. ¿En qué medida se ha visto afectada su vida diaria (trabajo, escuela, cuidado personal, vida social) por los pensamientos de contaminación y por limpiar, lavarse o ducharse de forma excesiva o realizar conductas de evitación?",
        "respuestas": [
            "0.- Mi vida no se ha visto afectada",
            "1.- Un poco afectada, pero en general funciono bien",
            "2.- Muchas facetas de mi vida están afectadas, pero a pesar de ello me manejo bien",
            "3.- Muchas facetas de mi vida están afectadas, y me cuesta funcionar",
            "4.- Mi vida está completamente afectada y no puedo funcionar en absoluto",

        ]
    },
    {
        "n": 'cat1-5',
        "pregunta": "5. Cuando intenta ignorar los pensamientos de contaminación y abstenerse de conductas como limpiar, lavarse, ducharse u otros rituales para descontaminarse, ¿le resulta difícil?",
        "respuestas": [
            "0.- En absoluto",
            "1.- Un poco difícil",
            "2.- Bastante difícil",
            "3.- Muy difícil",
            "4.- Extremadamente difícil",
        ]
    }
]

export const docs_catalog_2 = [
    {
        "n": 'cat2-1',
        "pregunta": "1. Aproximadamente, ¿cuánto tiempo le han ocupado al día los pensamientos sobre posibles daños o desastres y las comprobaciones o esfuerzos para que le tranquilicen asegurándole que esas cosas cosas no pasan (o no han pasado)?",
        "respuestas": [
            "0.- Ninguno/",
            "1.- Menos de una hora al día",
            "2.- Entre 1 y 3 horas al día",
            "3.- Entre 3 y 8 horas al día",
            "4.- Ocho horas o más al día",
        ]
    },
    {
        "n": 'cat2-2',
        "pregunta": "2. ¿Ha evitado situaciones para no tener que comprobar si había algún peligro o para no tener que preocuparse por la posibilidad de haber causado algún daño o provocado algún desastre?",
        "respuestas": [
            "0.- En absoluto",
            "1.- Evitación leve",
            "2.- Evitación moderada",
            "3.- Evitación grave",
            "4.- Evitación extrema de casi todas las cosas"
        ]
    },
    {
        "n": 'cat2-3',
        "pregunta": "3. Cuando ha tenido pensamientos sobre la posibilidad de provocar algún daño o desastre, o en el caso de no poder comprobar o pedir que le tranquilizaran, ¿cuánto malestar o ansiedad ha sentido?",
        "respuestas": [
            "0.- Ningún malestar/ansiedad",
            "1.- Ansiedad/malestar leve",
            "2.- Ansiedad/malestar moderado",
            "3.- Ansiedad/malestar grave",
            "4.- Ansiedad/malestar extremo",
        ]
    },
    {
        "n": 'cat2-4',
        "pregunta": "4. ¿En qué medida su vida diaria (trabajo, colegio, cuidado personal, vida social) se ha visto afectada por los pensamientos sobre causar algún daño o provocar desastres, o por comprobar demasiado o pedir que le tranquilicen en exceso?",
        "respuestas": [
            "0.- Mi vida no se ha visto afectada",
            "1.- Un poco afectada, pero en general funciono bien",
            "2.- Muchas facetas de mi vida están afectadas, pero a pesar de ello me manejo bien",
            "3.- Muchas facetas de mi vida están afectadas, y me cuesta funcionar",
            "4.- Mi vida está completamente afectada y no puedo funcionar en absoluto   ",
        ]
    },
    {
        "n": 'cat2-5',
        "pregunta": "5. Cuando intenta ignorar los pensamientos sobre daños o desastres y abstenerse de comprobar o de solicitar a otros que le tranquilicen, ¿le resulta difícil?",
        "respuestas": [
            "0.- En absoluto",
            "1.- Un poco difícil",
            "2.- Bastante difícil",
            "3.- Muy difícil",
            "4.- Extremadamente difícil",
        ]
    }
]

export const docs_catalog_3 = [
    {
        "n": 'cat3-1',
        "pregunta": "1. Aproximadamente, ¿cuánto tiempo le han ocupado al día los pensamientos desagradables no deseados y las acciones (físicas o mentales) que realiza debido a estos pensamientos?",
        "respuestas": [
            "0.- Ninguno",
            "1.- Menos de una hora al día",
            "2.- Entre 1 y 3 horas al día",
            "3.- Entre 3 y 8 horas al día",
            "4.- Ocho horas o más al día",
        ]
    },
    {
        "n": 'cat3-2',
        "pregunta": "2. ¿Ha evitado situaciones, lugares, objetos u otras cosas (por ejemplo, números o personas) que le desencadenan pensamientos no deseados o desagradables?",
        "respuestas": [
            "0.- En absoluto",
            "1.- Evitación leve",
            "2.- Evitación moderada",
            "3.- Evitación grave",
            "4.- Evitación extrema de casi todas las cosas",
        ]
    },
    {
        "n": 'cat3-3',
        "pregunta": "3. Cuando le han venido a la mente pensamientos no deseados o desagradables en contra de su voluntad, ¿ha sentido ansiedad o malestar?",
        "respuestas": [
            "0.- Ningún malestar/ansiedad",
            "1.- Ansiedad/malestar leve",
            "2.- Ansiedad/malestar moderado",
            "3.- Ansiedad/malestar grave",
            "4.- Ansiedad/malestar extremo",
        ]
    },
    {
        "n": 'cat3-4',
        "pregunta": "4. ¿En qué medida se ha visto afectada su vida diaria (trabajo, escuela, cuidado personal, vida social) a causa de estos pensamientos no deseados o desagradables o por las acciones (físicas y/o mentales) para evitar o afrontar estos pensamientos?",
        "respuestas": [
            "0.- Ningún tipo de alteración",
            "1.- Un poco de alteración, pero en general funciono bien",
            "2.- Bastantes cosas/aspectos están alteradas/os, pero todavía me manejo bien",
            "3.- Mi vida está alterada en muchos aspectos y tengo dificultades para afrontarla",
            "4.- Mi vida está completamente alterada y no puedo funcionar en absoluto",
        ]
    },
    {
        "n": 'cat3-5',
        "pregunta": "3. Cuando le han venido a la mente pensamientos no deseados o desagradables en contra de su voluntad, ¿ha sentido ansiedad o malestar?",
        "respuestas": [
            "O.- Nada difícil",
            "1.- Un poco difícil",
            "2.- Moderadamente difícil",
            "3.- Muy difícil",
            "4.- Extremadamente difícil",
        ]
    },
]

export const docs_catalog_4 = [
    {
        "n": 'cat4-1',
        "pregunta": "1. Aproximadamente, ¿cuánto tiempo le han ocupado al día los pensamientos no deseados sobre simetría, orden o equilibrio o las conductas dirigidas a conseguir simetría, orden o equilibrio?",
        "respuestas": [
            "O.- Ninguno",
            "1.- Menos de una hora al día",
            "2.- Entre 1 y 3 horas al día",
            "3.- Entre 3 y 8 horas al día",
            "4.- Ocho horas o más al día",
        ]
    },
    {
        "n": 'cat4-2',
        "pregunta": "2. ¿Ha evitado situaciones, lugares u objetos asociados con sensaciones de que algo no estaba simétrico o no estaba 'del todo bien'?",
        "respuestas": [
            "O.- En absoluto",
            "1.- Evitación leve",
            "2.- Evitación moderada",
            "3.- Evitación grave",
            "4.- Evitación extrema de casi todas las cosas",
        ]
    },
    {
        "n": 'cat4-3',
        "pregunta": "3. Cuando ha tenido la sensación de que algo no estaba 'del todo bien', ¿ha sentido malestar o ansiedad?",
        "respuestas": [
            "0.- Ningún malestar/ansiedad",
            "1.- Ansiedad/malestar leve",
            "2.- Ansiedad/malestar moderado",
            "3.- Ansiedad/malestar grave",
            "4.- Ansiedad/malestar extremo",
        ]
    },
    {
        "n": 'cat4-4',
        "pregunta": "4. ¿En qué medida se ha visto afectada su vida diaria (trabajo, escuela, cuidado personal, vida social) por la sensación de que las cosas no estaban 'del todo bien', y por los esfuerzos para conseguir que las cosas estuvieran en orden o como usted sentía que tenían que estar??",
        "respuestas": [
            "O.- Mi vida no se ha visto afectada",
            "1.- Un poco afectada, pero en general funciono bien",
            "2.- Muchas facetas de mi vida están afectadas, pero a pesar de ello me manejo bien",
            "3.- Muchas facetas de mi vida están afectadas, y me cuesta funcionar",
            "4.- Mi vida está completamente afectada y no puedo funcionar en absoluto.",
        ]
    },
    {
        "n": 'cat4-5',
        "pregunta": "5. Cuando intenta ignorar los pensamientos sobre la falta de simetría y orden, y no ceder al impulso de ordenar las cosas o de repetir ciertas conductas, ¿le resulta difícil?",
        "respuestas": [
            "O.- Nada difícil",
            "1.- Un poco difícil",
            "2.- Moderadamente difícil",
            "3.- Muy difícil",
            "4.- Extremadamente difícil",
        ]
    }
]